import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { LoaderService } from '@shared/services/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  constructor(
    private loaderService: LoaderService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.includes('https://www.auth.aidwatch.net/auth')) {
      this.loaderService.loading$.next(true);
    }
    return next.handle(req).pipe(
      tap(event => {
          this.disableLoader(event);
      }),
      catchError((err) => {
          this.disableLoader(err);
          throw err;
      })
    );
  }

  private disableLoader(response: HttpEvent<any>): void {
    if (response instanceof HttpErrorResponse || response instanceof HttpResponse) {
      this.loaderService.loading$.next(false);
    }
  }
}
